/** Payroll inclusion defaults by employment type (matches backend). */
export function payrollFlagDefaults(employmentType) {
  const t = employmentType || "Full-time";
  if (t === "Intern") return { include_in_payment: true, generate_payslip: false };
  if (t === "Contract" || t === "Part-time") {
    return { include_in_payment: false, generate_payslip: false };
  }
  return { include_in_payment: true, generate_payslip: true };
}

/** Coerce MySQL TINYINT 0/1, bool, or null → boolean | null (null = use type default). */
export function coercePayrollFlag(val) {
  if (val === null || val === undefined || val === "") return null;
  if (typeof val === "boolean") return val;
  if (typeof val === "number") return val !== 0;
  if (typeof val === "string") {
    const s = val.trim().toLowerCase();
    if (["1", "true", "yes", "y"].includes(s)) return true;
    if (["0", "false", "no", "n"].includes(s)) return false;
  }
  return Boolean(val);
}

/** Resolve flags for an employee (saved values or type defaults). */
export function resolvePayrollFlags(employee) {
  const type = employee?.employment?.employment_type || "Full-time";
  const defaults = payrollFlagDefaults(type);
  const sal = employee?.salary || {};
  const rawInclude = coercePayrollFlag(sal.include_in_payment);
  const rawSlip = coercePayrollFlag(sal.generate_payslip);
  let include = rawInclude != null ? rawInclude : defaults.include_in_payment;
  let slip = rawSlip != null ? rawSlip : defaults.generate_payslip;
  if (slip && !include) slip = false;
  return { include_in_payment: include, generate_payslip: slip };
}

/** Include in payment + eligible status → Generate Payroll / Generate Single. */
export function isPaymentEligibleEmployee(employee, eligibleStatuses) {
  const statusOk = eligibleStatuses.includes(employee?.employment?.status);
  if (!statusOk) return false;
  return resolvePayrollFlags(employee).include_in_payment === true;
}

/** Payment + Generate payslip Yes → employee-facing salary slip. */
export function isPayslipEligibleEmployee(employee, eligibleStatuses) {
  const statusOk = eligibleStatuses.includes(employee?.employment?.status);
  if (!statusOk) return false;
  const { include_in_payment, generate_payslip } = resolvePayrollFlags(employee);
  return include_in_payment && generate_payslip;
}

/** Payroll payment row issued without employee salary slip. */
export function isPaymentOnlyPayslip(payslip) {
  if (!payslip) return false;
  if (payslip.payment_only === true) return true;
  if (payslip.show_payslip === false) return true;
  return false;
}
